// extracted by mini-css-extract-plugin
module.exports = {"credits":"_18Ynoq","creditsCheckbox":"-NTKIc","price":"R9wgLg","shine-lines":"_2bJSQ2"};